import getRandomString from './getRandomString';

const getOrCreateDeviceIdentity = (deviceKey) => {
  const fewcentDeviceKey = localStorage.getItem(deviceKey);

  if (fewcentDeviceKey) {
    return fewcentDeviceKey;
  }
  const uid = getRandomString(15);
  localStorage.setItem(deviceKey, uid);
  return uid;
};

export default getOrCreateDeviceIdentity;
